import { useState } from "react";
import { CheckboxSingleSettings } from "./customPropertyConfig";
import { MySwitch } from "../../shared/MySwitch";

type AppCustomPropertySettingsCheckboxSingleProps = {
  settings: CheckboxSingleSettings;
  onChange: (settings: CheckboxSingleSettings) => void;
};

export const AppCustomPropertySettingsCheckboxSingle = ({
  settings,
  onChange,
}: AppCustomPropertySettingsCheckboxSingleProps) => {
  return (
    <div className="app-custom-property-settings-container">
      <div className="app-custom-property-group">
        <div className="app-custom-property-label">Default On</div>
        <div className="app-custom-property-value">
          <MySwitch
            checked={settings.checked}
            onChange={(checked: boolean) => {
              onChange({
                ...settings,
                checked,
              });
            }}
          />
        </div>
      </div>

      <div className="app-custom-property-group">
        <div className="app-custom-property-label">Choice</div>
        <div className="app-custom-property-value">
          <input
            title={settings.choice}
            type="text"
            value={settings.choice}
            onChange={(event) => {
              onChange({
                ...settings,
                choice: event.target.value,
              });
            }}
          />
        </div>
      </div>
    </div>
  );
};
